// extracted by mini-css-extract-plugin
export default {"main":"BlockVideosManagement_main__jZKKW"};